export default __webpack_public_path__ + "static/media/NEOUs.690740ea.png";